/** Traductions gestionnaire lots pharmacie (FR / AR) */
export const pharmacyLotManagerFr = {
  title: 'Gestion des lots pharmacie',
  subtitle: 'Gérer les lots de médicaments avec suivi de conformité',
  complianceReport: 'Rapport de conformité',
  addLot: 'Ajouter un lot',
  filterMedicationType: 'Type de médicament',
  filterCompliance: 'Conformité',
  filterStatus: 'Statut',
  filterSearch: 'Recherche',
  allTypes: 'Tous les types',
  allCompliance: 'Toute conformité',
  allStatus: 'Tous les statuts',
  medPrescription: 'Sur ordonnance',
  medOtc: 'Sans ordonnance',
  medControlled: 'Substance contrôlée',
  medVaccine: 'Vaccin',
  medDevice: 'Dispositif médical',
  medSupplement: 'Complément',
  medUnknown: 'Type inconnu',
  complianceCompliant: 'Conforme (≥80 %)',
  complianceNonCompliant: 'Non conforme (<80 %)',
  complianceCritical: 'Critique (<50 %)',
  statusActive: 'Actif',
  statusExpired: 'Expiré',
  statusRecalled: 'Rappelé',
  statusQuarantined: 'En quarantaine',
  statusTempViolation: 'Violation de température',
  statusSoldOut: 'Épuisé',
  statusTransferred: 'Transféré',
  statusQualityControl: 'Contrôle qualité',
  statusRegulatoryHold: 'Retenu réglementaire',
  statusUnknown: 'Statut inconnu',
  searchPlaceholder: 'Rechercher des lots…',
  lotsTitle: 'Lots de médicaments ({{count}})',
  colBatchNumber: 'N° de lot',
  colMedicationType: 'Type',
  colStorage: 'Stockage',
  colCompliance: 'Conformité',
  colStatus: 'Statut',
  colExpiration: 'Expiration',
  colActions: 'Actions',
  prescriptionRequired: 'Ordonnance requise',
  controlledSubstance: 'Substance contrôlée',
  storageAmbient: 'Ambiant',
  daysUntilExpiry: '{{count}} jours',
  actionView: 'Voir les détails',
  actionEdit: 'Modifier le lot',
  actionDelete: 'Supprimer le lot',
  modalAddTitle: 'Ajouter un lot pharmacie',
  productIdLabel: 'ID produit',
  productIdPlaceholder: 'Saisir l\'ID produit',
  medicationTypeLabel: 'Type de médicament',
  purchasePriceLabel: 'Prix d\'achat (MRU)',
  sellingPriceLabel: 'Prix de vente (MRU)',
  quantityLabel: 'Quantité',
  expirationDateLabel: 'Date d\'expiration',
  supplierLabel: 'Fournisseur',
  supplierPlaceholder: 'Nom du fournisseur',
  storageRequirementLabel: 'Exigence de stockage',
  cancel: 'Annuler',
  addLotConfirm: 'Ajouter le lot',
  reportTitle: 'Rapport de conformité pharmacie',
  export: 'Exporter',
  close: 'Fermer',
  totalLots: 'Total lots',
  compliant: 'Conformes',
  nonCompliant: 'Non conformes',
  overallScore: 'Score global',
  recommendations: 'Recommandations',
  complianceScoreCol: 'Score de conformité',
  violationsCol: 'Violations',
  issuesCol: 'Problèmes',
  issueExpired: 'Expiré',
  issueRecalled: 'Rappelé',
  issueTemperature: 'Problèmes de température'
};

export const pharmacyLotManagerAr = {
  title: 'إدارة دفعات الصيدلية',
  subtitle: 'إدارة دفعات الأدوية مع تتبع الامتثال',
  complianceReport: 'تقرير الامتثال',
  addLot: 'إضافة دفعة',
  filterMedicationType: 'نوع الدواء',
  filterCompliance: 'الامتثال',
  filterStatus: 'الحالة',
  filterSearch: 'بحث',
  allTypes: 'جميع الأنواع',
  allCompliance: 'كل مستويات الامتثال',
  allStatus: 'جميع الحالات',
  medPrescription: 'بوصفة طبية',
  medOtc: 'بدون وصفة',
  medControlled: 'مادة خاضعة للرقابة',
  medVaccine: 'لقاح',
  medDevice: 'جهاز طبي',
  medSupplement: 'مكمل',
  medUnknown: 'نوع غير معروف',
  complianceCompliant: 'ممتثل (≥80٪)',
  complianceNonCompliant: 'غير ممتثل (<80٪)',
  complianceCritical: 'حرج (<50٪)',
  statusActive: 'نشط',
  statusExpired: 'منتهي الصلاحية',
  statusRecalled: 'مسحوب',
  statusQuarantined: 'في الحجر',
  statusTempViolation: 'مخالفة درجة الحرارة',
  statusSoldOut: 'نفد',
  statusTransferred: 'منقول',
  statusQualityControl: 'مراقبة الجودة',
  statusRegulatoryHold: 'احتجاز تنظيمي',
  statusUnknown: 'حالة غير معروفة',
  searchPlaceholder: 'البحث في الدفعات…',
  lotsTitle: 'دفعات الأدوية ({{count}})',
  colBatchNumber: 'رقم الدفعة',
  colMedicationType: 'النوع',
  colStorage: 'التخزين',
  colCompliance: 'الامتثال',
  colStatus: 'الحالة',
  colExpiration: 'انتهاء الصلاحية',
  colActions: 'الإجراءات',
  prescriptionRequired: 'يتطلب وصفة',
  controlledSubstance: 'مادة خاضعة للرقابة',
  storageAmbient: 'درجة حرارة الغرفة',
  daysUntilExpiry: '{{count}} يوم',
  actionView: 'عرض التفاصيل',
  actionEdit: 'تعديل الدفعة',
  actionDelete: 'حذف الدفعة',
  modalAddTitle: 'إضافة دفعة صيدلية',
  productIdLabel: 'معرف المنتج',
  productIdPlaceholder: 'أدخل معرف المنتج',
  medicationTypeLabel: 'نوع الدواء',
  purchasePriceLabel: 'سعر الشراء (أوقية)',
  sellingPriceLabel: 'سعر البيع (أوقية)',
  quantityLabel: 'الكمية',
  expirationDateLabel: 'تاريخ انتهاء الصلاحية',
  supplierLabel: 'المورد',
  supplierPlaceholder: 'اسم المورد',
  storageRequirementLabel: 'متطلبات التخزين',
  cancel: 'إلغاء',
  addLotConfirm: 'إضافة الدفعة',
  reportTitle: 'تقرير امتثال الصيدلية',
  export: 'تصدير',
  close: 'إغلاق',
  totalLots: 'إجمالي الدفعات',
  compliant: 'ممتثل',
  nonCompliant: 'غير ممتثل',
  overallScore: 'النتيجة الإجمالية',
  recommendations: 'التوصيات',
  complianceScoreCol: 'درجة الامتثال',
  violationsCol: 'المخالفات',
  issuesCol: 'المشكلات',
  issueExpired: 'منتهي الصلاحية',
  issueRecalled: 'مسحوب',
  issueTemperature: 'مشاكل درجة الحرارة'
};
